const ITEMS = [
  'Redefining Water',
  '15 Years of Excellence',
  'Highflow Technology',
  'Solid Brass Craft',
  'Eco Friendly',
  'Quality Control Approved',
  'Made in Bhiwadi, Rajasthan',
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-[#D4AF37]/15 bg-[#0D0D0F] py-5 overflow-hidden select-none"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-xl sm:text-2xl text-zinc-600 px-8 whitespace-nowrap">
                  {t}
                </span>
                <span className="text-[#D4AF37]/40 text-xs">&#9670;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
